import React, { useEffect } from 'react';
import { AppBar, Stack, Typography } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';

import { LanguageSwitch, NavigationBar } from '@/components';
import { AccountInfoUtil } from '@/features/account';
import { AUTH_ROUTE } from '@/routes';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const Layout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('AUTH_TOKEN');
    if (token === null) {
      navigate(AUTH_ROUTE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack direction="column" alignItems="center" justifyContent="center">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <AppBar
          position="fixed"
          sx={{
            ...styles.appBar,
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%', height: '100%', padding: '0 24px' }}
          >
            <Typography variant="h1" sx={{ color: palette.text.primary }}>
              Administrace
            </Typography>

            <Stack direction="row" alignItems="center" gap={2}>
              <LanguageSwitch />
              <AccountInfoUtil />
            </Stack>
          </Stack>
        </AppBar>
      </Stack>

      <Stack direction="row">
        <NavigationBar />
        <Stack sx={styles.content}>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  );
};
